import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App.jsx';
import { NikkeIconProvider } from './features/nikke-icons/shared/NikkeIconProvider.jsx';
import { registerDororaidServiceWorker } from './features/pwa/api/pushApi.js';
import { installMobileChatComposerFocusGuard } from './features/raid-control/shared/mobileChatComposerFocusGuard.js';
import { installMobileChatViewportRecovery } from './features/raid-control/shared/mobileChatViewportRecovery.js';
import { installMobileChatToolbarViewportLock } from './features/raid-control/shared/mobileChatToolbarViewportLock.js';
import { installRaidControlChatLatestScroll } from './features/raid-control/shared/raidControlChatLatestScroll.js';
import { installRaidControlViewPersistence } from './features/raid-control/shared/raidControlViewPersistence.js';
import './styles/tokens.css';
import './styles/base.css';
import './styles/button-system.css';
import './styles/icon-actions.css';
import './styles/dororaid-icons.css';
import './styles/doroparty-brand.css';
import './styles/site-footer.css';
import './styles/desktop.css';
import './styles/desktop-pages.css';
import './styles/mobile.css';
import './styles/mobile-pages.css';
import './styles/mobile-topbar-actions.css';
import './styles/auth-desktop.css';
import './styles/auth-mobile.css';
import './styles/personal-code-auth.css';
import './styles/personal-code-auth-current-code.css';
import './styles/account-desktop.css';
import './styles/account-mobile.css';
import './styles/game-profile-desktop.css';
import './styles/game-profile-mobile.css';
import './styles/my-info.css';
import './styles/my-info-avatar.css';
import './styles/pwa-push.css';
import './styles/mobile-install-prompt.css';
import './styles/platform-union-review-desktop.css';
import './styles/platform-union-review-mobile.css';
import './styles/platform-account-moderation.css';
import './styles/platform-chat-moderation.css';
import './styles/platform-union-management.css';
import './styles/platform-sticker-management.css';
import './styles/broadcast-management.css';
import './styles/entry-community-type.css';
import './styles/nikke-master-sync.css';
import './styles/platform-management-layout.css';
import './styles/union-member-management-desktop.css';
import './styles/union-member-management-mobile.css';
import './styles/union-leadership-transfer.css';
import './styles/union-roster.css';
import './styles/member-push-status.css';
import './styles/union-member-detail.css';
import './styles/member-availability.css';
import './styles/raid-season-desktop.css';
import './styles/raid-season-mobile.css';
import './styles/raid-season-actions.css';
import './styles/raid-season-boss-catalog.css';
import './styles/raid-bridge-desktop.css';
import './styles/raid-bridge-mobile.css';
import './styles/raid-bridge-installer.css';
import './styles/raid-bridge-onboarding.css';
import './styles/raid-bridge-desktop-guide.css';
import './styles/raid-bridge-token-paste.css';
import './styles/raid-bridge-direct.css';
import './styles/raid-bridge-topbar.css';
import './styles/raid-overview-desktop.css';
import './styles/raid-overview-panels.css';
import './styles/raid-overview-detail.css';
import './styles/raid-overview-mobile.css';
import './styles/raid-integrity.css';
import './styles/raid-settlement.css';
import './styles/raid-settlement-comment.css';
import './styles/raid-settlement-insights.css';
import './styles/raid-clear-status.css';
import './styles/union-notices.css';
import './styles/union-notice-comment-collapse.css';
import './styles/union-support.css';
import './styles/site-support-standalone.css';
import './styles/raid-practice-desktop.css';
import './styles/raid-practice-mobile.css';
import './styles/raid-practice-catalog.css';
import './styles/raid-practice-original-desktop.css';
import './styles/raid-practice-original-mobile.css';
import './styles/raid-practice-original-v2.css';
import './styles/raid-practice-desktop-carousel.css';
import './styles/raid-practice-element-cards.css';
import './styles/raid-practice-slot-icons.css';
import './styles/raid-practice-mobile-desktop-parity.css';
import './styles/raid-practice-admin.css';
import './styles/raid-practice-admin-actions.css';
import './styles/raid-practice-admin-compact.css';
import './styles/raid-practice-cards.css';
import './styles/raid-practice-squad-detail.css';
import './styles/raid-practice-squad-detail-mobile.css';
import './styles/raid-practice-picker-desktop.css';
import './styles/raid-practice-picker-mobile.css';
import './styles/nikke-picker-sort.css';
import './styles/raid-practice-recommendations.css';
import './styles/recommended-decks.css';
import './styles/recommended-deck-load-scroll.css';
import './styles/recommended-deck-editor.css';
import './styles/shared-controls.css';
import './styles/raid-tetris.css';
import './styles/raid-tetris-recommend.css';
import './styles/raid-tetris-alternative-tabs.css';
import './styles/raid-tetris-full-simulation.css';
import './styles/raid-tetris-full-simulation-controls.css';
import './styles/raid-tetris-full-tradeoff-dialog.css';
import './styles/raid-tetris-access-sources.css';
import './styles/raid-tetris-controls.css';
import './styles/raid-tetris-matrix.css';
import './styles/raid-tetris-deck-strips.css';
import './styles/raid-tetris-global-plan.css';
import './styles/entry-gate-desktop.css';
import './styles/entry-gate-mobile.css';
import './styles/raid-tetris-candidate-selector.css';
import './styles/page-refresh-placement.css';
import './styles/nikke-icons.css';
import './styles/raid-settlement-elements.css';
import './styles/raid-tetris-icon-layout.css';
import './styles/raid-tetris-responsive-cards.css';
import './styles/raid-tetris-slot-card-layout.css';
import './styles/raid-infinity-focus.css';
import './styles/personal-nikke.css';
import './styles/personal-nikke-member-selector.css';
import './styles/personal-nikke-mobile-layout.css';
import './styles/personal-nikke-surface.css';
import './styles/raid-practice-overload-toggle.css';
import './styles/doroparty-brand-layout.css';
import './styles/desktop-sidebar-scale.css';
import './styles/navigation-badges.css';
import './styles/raid-strategy-board.css';
import './styles/raid-strategy-actual.css';
import './styles/raid-strategy-mode-tabs.css';
import './styles/raid-strategy-deck-containment.css';
import './styles/raid-strategy-compact.css';
import './styles/raid-strategy-slot-entry.css';
import './styles/raid-strategy-practice-cards.css';
import './styles/raid-strategy-recommend-dialog.css';
import './styles/raid-strategy-placement-dialog.css';
import './styles/raid-strategy-slot-mobile.css';
import './styles/raid-practice-three-hit.css';
import './styles/raid-practice-three-hit-mobile.css';
import './styles/raid-entry-portrait-containment.css';
import './styles/page-capture-placement.css';
import './styles/action-button-consistency.css';
import './styles/raid-practice-slot-actions.css';
import './styles/raid-practice-admin-desktop-density.css';
import './styles/raid-practice-interactions.css';
import './styles/raid-practice-filter-menu.css';
import './styles/raid-practice-compact-boss-selector.css';
import './styles/raid-practice-mobile-ui-parity.css';
import './styles/raid-practice-slot-drag.css';
import './styles/raid-practice-mobile-admin-actions.css';
import './styles/raid-practice-admin-control-alignment.css';
import './styles/raid-practice-admin-single-boss-view.css';
import './styles/raid-practice-desktop-controls.css';
import './styles/raid-practice-mobile-entry.css';
import './styles/raid-practice-record-table.css';
import './styles/raid-practice-admin-board-controls.css';
import './styles/raid-control-mobile-boss-overlay.css';
import './styles/raid-control-mobile-scroll-performance.css';
import './styles/raid-control-practice-inspector.css';
import './styles/raid-control-wide-layout.css';
import './styles/raid-control-chat.css';
import './styles/raid-control-chat-enhancements.css';
import './styles/raid-control-result-card.css';
import './styles/raid-control-tetris-share.css';
import './styles/raid-control-chat-latest.css';
import './styles/mobile-popup-safe-area.css';
import './styles/raid-control-mobile-frame.css';

installMobileChatComposerFocusGuard();
installMobileChatViewportRecovery();
installMobileChatToolbarViewportLock();
installRaidControlChatLatestScroll();
installRaidControlViewPersistence();
registerDororaidServiceWorker().catch((error) => console.warn('Service worker registration failed', error));

createRoot(document.getElementById('root')).render(
  <React.StrictMode><NikkeIconProvider><App /></NikkeIconProvider></React.StrictMode>,
);